export default{
  'monetization_ltv_LTV': 'LTV', // 1
  'monetization_ltv_LTV_of_7/30/180_Days': 'LTV of 7/30/180 Days({unit})', // 2
  'monetization_ltv_Average_7D_LTV': 'Average 7D LTV', // 3
  'monetization_ltv_Average_30D_LTV': 'Average 30D LTV', // 4
  'monetization_ltv_Average_180D_LTV': 'Average 180D LTV',
  'monetization_ltv_LTV_Tracking_for_Daily_Registered_Users': 'LTV Tracking for Daily Registered Users', // 5
  'monetization_ltv_Key_Days': 'Key Days', // 7
  'monetization_ltv_Date': 'Date', // 8
  'monetization_ltv_Register_Users': 'Register Users', // 9
  'monetization_ltv_': '1D LTV', // 1天LTV
  'monetization_ltv_7D_LTV': '7D LTV', // 1天LTV
  'monetization_ltv_30D_LTV': '30D LTV', // 1天LTV
  'monetization_ltv_180D_LTV': '180D LTV', // 1天LTV
  'monetization_ltv_Register': 'Register', //
  'monetization_ltv_D': 'D', //
  'monetization_ltv_Revenue($)': 'Revenue({unit})', //

}
